import React from 'react';
import { Link } from 'react-router-dom';
import './navbar.css';
import logo from '../assets/logo.jpg';
import rightLogo from '../assets/logo2.jpg'; // <- Add this image to assets
import { FaEnvelope, FaPhone } from 'react-icons/fa';

const Navbar = () => {
  return (
    <>
      {/* <div className="top-bar">
        <p>Reg. No:- Reg. No.: SAN / JAT / RSR / (CR) 2125/2024 Dt. 05/02/2024</p>
      </div> */}

      <div className="navbar-header">
        <div className="navbar-left">
  <Link to="/" className="navbar-home-link">
    <img src={logo} alt="Logo" className="logo"/>
    <div className="divider"></div>
    <div className="title">
      <h1>श्री वरद विनायक </h1>
      <p>को-ऑप. क्रेडीट सोसायटी लि. डफळापुर</p>    
      <p>Reg. No:- Reg. No.: SAN / JAT / RSR / (CR) 2125/2024 Dt. 05/02/2024</p>  
    </div>
  </Link>
</div>
    <div className="navbar-right">
    {/* <img src={rightLogo} alt="Right Logo" className="right-logo" /> */}
    <p>
    <a href="mailto:varadvinayaks940@gmail.com">
      varadvinayaks940@gmail.com <FaEnvelope style={{ marginLeft: '6px', verticalAlign: 'middle' }} />
    </a>
    </p>
    <p>
    <a href="tel:+91 9373330114">
      +91 9373330114 <FaPhone style={{ marginLeft: '6px', verticalAlign: 'middle' }} />
    </a>
    </p>
  </div>

      </div>

      <nav className="nav-links-bar">
        <ul className="nav-links">
          <li><Link to="/">मुख्यपान</Link></li>
          <li><Link to="/about">विषय माहिती</Link></li>
          {/* <li className="nav-item dropdown">
            <span className="dropbtn">खाते▾</span>
            <div className="dropdown-content">
              <Link to="/bachat-khata">बचत खाते</Link>
            </div>
          </li> */}
          <li className="nav-item dropdown">
            <span className="dropbtn">ठेवी योजना▾</span>
            <div className="dropdown-content">
              <Link to="/mudat-thev">मुदत ठेव योजना</Link>
              <Link to="/damdupat-thev">दाम दुप्पट ठेव योजना</Link>
            </div>
          </li>
          <li className="nav-item dropdown">
            <span className="dropbtn">कर्ज योजना▾</span>
            <div className="dropdown-content">
              <Link to="/sone-taran-karj">सोने तारण कर्ज</Link>
              <Link to="/vahan-taran-karj">वाहन तारण कर्ज</Link>
              <Link to="/mortgage-karj">मॉर्गेज तारण कर्ज</Link>
              <Link to="/grah-karj">गृह कर्ज</Link>
              <Link to="/sabhasad-karj">सभासद कर्ज</Link>
            </div>
          </li>
          {/* <li className="nav-item dropdown">
            <span className="dropbtn">सेवा</span>
            <span className="dropbtn">पतसंस्थेबद्दल</span> */}
            {/* <div className="dropdown-content">
              <Link to="/about">विषय माहिती</Link>
              <Link to="/directors-message">अध्यक्षांचे मनोगत</Link>
              <Link to="/Photo Gallery">फोटो गॅलरी</Link>
              <Link to="/certificate">प्रमाणपत्र</Link>
            </div>
          </li> */} 
          <li><Link to="/SevaPage">सेवा</Link></li>
          <li><Link to="/Photo Gallery">फोटो गॅलरी</Link></li>
          <li><Link to="/contact">संपर्क</Link></li>          
        </ul>
      </nav>
    </>
  );
};

export default Navbar;
